import { shallowRef, type ComputedRef, type Ref } from 'vue'
import { defineStore } from 'pinia'

export type HeaderActionValue<T> = T | Ref<T> | ComputedRef<T>

export interface HeaderAction {
  label: HeaderActionValue<string>
  icon: string
  testId?: string
  title?: HeaderActionValue<string>
  disabled?: HeaderActionValue<boolean>
  loading?: HeaderActionValue<boolean>
  iconOnly?: boolean
  expanded?: HeaderActionValue<boolean>
  controls?: string
  onClick: () => void | Promise<void>
}

export interface SourceFileHeaderActions {
  download: HeaderAction
  details: HeaderAction
}

export const useHeaderActionsStore = defineStore('headerActions', () => {
  const fileSearch = shallowRef<HeaderAction | null>(null)
  const reviewSave = shallowRef<HeaderAction | null>(null)
  const reviewDiscard = shallowRef<HeaderAction | null>(null)
  const sourceFile = shallowRef<SourceFileHeaderActions | null>(null)

  function setSourceFile(actions: SourceFileHeaderActions): void {
    sourceFile.value = actions
  }

  function clearSourceFile(actions: SourceFileHeaderActions): void {
    if (sourceFile.value === actions) sourceFile.value = null
  }

  function setFileSearch(action: HeaderAction | null): void {
    fileSearch.value = action
  }

  function clearFileSearch(action?: HeaderAction | null): void {
    if (!action || fileSearch.value === action) fileSearch.value = null
  }

  function setReviewActions(actions: {
    save?: HeaderAction | null
    discard?: HeaderAction | null
  }): void {
    reviewSave.value = actions.save ?? null
    reviewDiscard.value = actions.discard ?? null
  }

  return {
    fileSearch,
    reviewSave,
    reviewDiscard,
    sourceFile,
    setSourceFile,
    clearSourceFile,
    setFileSearch,
    clearFileSearch,
    setReviewActions,
  }
})
